import React from 'react';
import { Tooltip as AntdTooltip } from 'antd';
import type { TooltipProps as AntdTooltipProps } from 'antd';
import classnames from 'classnames';

import cn from './styles.module.scss';

export type TooltipProps = AntdTooltipProps;

export function Tooltip({
  classNames,
  children,
  ...props
}: TooltipProps) {
  const resolvedClassNames = typeof classNames === 'object' ? classNames : undefined;
  return (
    <AntdTooltip
      classNames={{
        ...resolvedClassNames,
        root: classnames(cn.root, resolvedClassNames?.root),
        container: classnames(cn.container, resolvedClassNames?.container),
      }}
      {...props}
    >
      {/* rc-trigger (under antd Tooltip) calls getBoundingClientRect on a ref
          to the child to position the popup. If consumers pass a function
          component that doesn't forward refs, the ref is null and placement
          breaks. Wrapping in a div guarantees a measurable DOM element
          regardless of what the consumer passes. */}
      <div>{children}</div>
    </AntdTooltip>
  );
}
